import { ArsContextState, IArsActionSetSidebarDataset } from "../interface";

/**
 * Sets the sidebar dataset filter.
 *
 * @param state - Current ARS context state
 * @param action - Set-sidebar-dataset action
 * @returns Updated state with sidebar dataset changed
 */
export const arsc_setSidebarDataset = <T>(
  state: ArsContextState<T>,
  action: IArsActionSetSidebarDataset,
): ArsContextState<T> => ({
  ...state,
  currentSidebar: {
    ...state.currentSidebar,
    dataset: action.dataset,
  },
});
